export enum ChatReportReasonEnum {
  SPAM = 1,
  HATE = 2,
  BULLYING = 3,
  VIOLENT_CONTENT = 4,
  ADULT_CONTENT = 5,
  FRAUD = 6,
  INTELLECTUAL_PROPERTY = 7,
  IMPERSONATION = 8,
}

export const CHAT_REPORT_REASON_LABELS = {
  [ChatReportReasonEnum.SPAM]: 'スパム/宣伝目的',
  [ChatReportReasonEnum.HATE]: 'ヘイト',
  [ChatReportReasonEnum.BULLYING]: 'いじめ、いやがらせ、虐待',
  [ChatReportReasonEnum.VIOLENT_CONTENT]: '暴力的、不快、または悪意があるコンテンツ',
  [ChatReportReasonEnum.ADULT_CONTENT]: '成人向けコンテンツ',
  [ChatReportReasonEnum.FRAUD]: '詐欺または虚偽の情報',
  [ChatReportReasonEnum.INTELLECTUAL_PROPERTY]: '知的財産権',
  [ChatReportReasonEnum.IMPERSONATION]: 'なりすまし',
} as const;